import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
import "./styles.css";

const theme=localStorage.getItem("theme");if(theme)document.documentElement.dataset.theme=theme;
if("serviceWorker" in navigator&&import.meta.env.PROD)navigator.serviceWorker.register("/sw.js").catch(()=>{});
const client=new QueryClient({defaultOptions:{queries:{staleTime:15000,retry:1},mutations:{retry:0}}});
ReactDOM.createRoot(document.getElementById("root")!).render(<React.StrictMode><QueryClientProvider client={client}><RouterProvider router={router}/></QueryClientProvider></React.StrictMode>);

